<template>
  <v-container fluid class="py-0 px-3">
    <v-flex class="justify-center body-container">
      <v-row class="d-flex  justify-center align-center main-body">
        <v-col>
          <v-row class="d-flex align-center justify-center">
            <v-col>
              <p class="hero-text">
                pull requests and personal records
              </p>
              <p class="details-text">
                ever since I was a little girl, I knew I wanted to be on the computer a lot ✨
              </p>
            </v-col>
          </v-row>      
        </v-col>
      </v-row>
      <aboutMe 
      />
    </v-flex>
  </v-container>
</template>

<script>
import aboutMe from './aboutMe.vue';

export default {
    title: 'Darcey Grundy | Home',
    name: 'HomePage',
    components: {
      aboutMe,
    },
    data: () => ({
    }),
    computed: {
      mobile() {
        return this.$vuetify.breakpoint.mdAndDown
      },
    }
  }
</script>

<style lang="scss" scoped>
.body-container {
  padding: 4px 16px;

  @media (min-width: 800px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  .main-body {
    padding-top: 80px;

    @media (min-width: 800px) {
      padding-top: 200px;
    }

    p {
      font-family: Gasoek One;
      color: var(--v-tropicalIndigo-base);
    }

    .hero-text {
      font-size: 40px;
      padding-top: 20px;
      letter-spacing: 10%;
      font-weight: 400; 

      @media (min-width: 800px) {
        font-size: 80px;
      }
    }

    .details-text {
      font-size: 30px;
    }
  }
}
</style>